<script>
import Layout from '@layouts/main'
import lazyLoadComponent from '@router/lazyload-component'
import { genderFilter } from '@utils/filter-value-to-text'
import BaseButtonDialog from '@components/BaseButtonDialog'

export default {
  page: {
    title: '查看客戶資訊',
    meta: [{ name: 'description', content: 'View Member' }],
  },
  filters: { genderFilter },
  components: {
    Layout,
    BaseButtonDialog,
    NotificationWrite: () =>
      lazyLoadComponent(import('@components/NotificationWrite')),
  },
  props: {
    defaultValue: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      activeTabIndex: 0,
      noti:0,
      dialogVisible: false,
      sideTabList: [
        {
          icon: 'edit',
          title: '編輯客戶資訊',
          name: 'edit',
          component: () => import('./DetailEdit'),
        },
        {
          icon: 'history',
          title: '所有預訂紀錄',
          name: 'orders',
          component: () => import('./DetailOrders'),
        },
      ],
      componentData: Object.assign({},this.defaultValue)
    }
  },
  computed: {
    activeTab() {
      return this.sideTabList[this.activeTabIndex]
    },
  },
  methods: {
    backToList() {
      this.$router.push({ name: 'member' })
    },
    closeDialog() {
      this.dialogVisible = false
    },
  },
}
</script>

<template>
  <Layout>
    <div :class="$style.wrapper">
      <div :class="$style.sidebar">
        <div :class="$style.header">
          <el-page-header title="返回列表" @back="backToList"></el-page-header>
          <div :class="$style.intro">
            <el-avatar
              :src="require(`@assets/images/member_avatar_${defaultValue.gender || 'female'}.png`)"
              :size="100"
            ></el-avatar>

            <h3>{{ defaultValue.fullName }} {{ defaultValue.gender | genderFilter }}</h3>
            <ul class="is-info">
              <li>{{ `${defaultValue.phoneCode} ${defaultValue.phoneNumber}` }}</li>
              <li>{{ defaultValue.email }}</li>
            </ul>
          </div>
        </div>

        <div :class="$style.overview">
          <div :class="$style['overview__item']">
            <div :class="$style['overview__value']">{{ defaultValue.ordersCounts }}</div>有效訂單筆數
          </div>
          <div :class="$style['overview__item']">
            <div :class="$style['overview__value']">{{ defaultValue.ordersTotal }}</div>累積消費金額
          </div>
        </div>

        <el-radio-group v-model="activeTabIndex" class="is-block" :class="$style.tabs">
          <el-radio-button v-for="(tab, $index) in sideTabList" :key="tab.name" :label="$index">
            <BaseIcon :name="tab.icon" />
            <span>{{tab.title}}</span>
          </el-radio-button>
        </el-radio-group>



          <el-radio-group class="is-block" :class="$style.tabs">
          <el-radio-button :class="$style.enabled" :label="1" @click.native="dialogVisible = true" disabled>
            <BaseIcon name="mail-bulk" />
            <span>撰寫通知</span>
          </el-radio-button>
          <el-radio-button v-show="false" :label="0" @click.native="dialogVisible = true">
          </el-radio-button>
        </el-radio-group>

      </div>
      <div :class="$style.content">
        <keep-alive>
          <component
            :is="activeTab.component"
            :key="activeTab.name"
            :default-value.sync="componentData"
          ></component>
        </keep-alive>
      </div>

      <BaseButtonDialog
        :only-dialog="true"
        :title="'撰寫通知'"
        :dialog-visible.sync="dialogVisible"
        :destroy="true"
        floating
      >
        <NotificationWrite
        :selected-member-ids="[defaultValue.id]"
          :source-name="'member'"
          :source-member="defaultValue"
          @close="closeDialog"
        />
      </BaseButtonDialog>
    </div>
  </Layout>
</template>

<style lang='scss' module>
@import '@design';
@import '@src/design/layout_detail_sidebar.scss';

.intro {
  margin-top: 30px;
  text-align: center;
}
.enabled{
  :global{
.el-radio-button__orig-radio:disabled + .el-radio-button__inner{
    color: inherit;
    cursor: pointer;
    &:hover{
      color: $color-primary;
    }
  }
  }
  
}
</style>